import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBlock, CardTitle , Button} from 'reactstrap';

import ReactTable from "react-table";
import "react-table/react-table.css";
import IconEdit from 'react-icons/lib/md/edit';
import IconPersonAdd from 'react-icons/lib/md/person-add';
import IconBan from "react-icons/lib/fa/ban";

import * as actions from '../../actions/movimientocaproveedores';
import Modal from "./Modal";
import _ from "lodash";
import {api} from '../../actions/_request';

import Menu from '../facturacion/menu.js';
import swal from 'sweetalert2';
import moment from 'moment';

const requestData = (pageSize, page, sorted, filtered) => {    
    return new Promise((resolve, reject) => {
        // You can retrieve your data however you want, in this case, we will just use some local data.
        let filteredData ;
        var fecha="";
        var factura="";
        var concepto="";
        var referencia="";
        var proveedor="";
        var proveedor_id="";
        var take= pageSize;
        var skip=pageSize * page;
        var total=1;  
        for (var i = filtered.length - 1; i >= 0; i--) {
          switch(filtered[i].id)
          {
            case "fecha":
              fecha=filtered[i].value;
              break;
            case "refdoc":
              factura=filtered[i].value;
              break;            
            case "referencia":
              referencia=filtered[i].value;
              break;
            case "concepto":
              concepto=filtered[i].value;
              break;   
             case "proveedor":
              proveedor=filtered[i].value;
              break;   
            case "codigo_proveedor":
              proveedor_id=filtered[i].value;
              break;         
          }
        }
        api().get(`/movimientocapconteo/conteo?referencia=${referencia}&fecha=${fecha}&factura=${factura}&concepto=${concepto}&proveedor=${proveedor}&proveedor_id=${proveedor_id}&take=${take}&skip=${skip}`)
        .then(function(response)
        {
            if(response.status === 200)
            {
              total= response.data[0].total; 
              api().get(`/movimientocapbusqueda/busqueda?referencia=${referencia}&fecha=${fecha}&factura=${factura}&concepto=${concepto}&proveedor=${proveedor}&proveedor_id=${proveedor_id}&take=${take}&skip=${skip}`)
              .then(function(response)
              {
                if(response.status === 200)
                {
                  filteredData= response.data; 
                  // You can also use the sorting in your request, but again, you are responsible for applying it.
                  const sortedData = _.orderBy(
                    filteredData,
                    sorted.map(sort => {
                      return row => {
                        if (row[sort.id] === null || row[sort.id] === undefined) {
                          return -Infinity;
                        }
                        return typeof row[sort.id] === "string"
                        ? row[sort.id].toLowerCase()
                        : row[sort.id];
                      };
                    }),
                    sorted.map(d => (d.desc ? "desc" : "asc"))
                  );
                  const res = {
                    rows: sortedData,
                    pages: Math.ceil(total / pageSize)
                  };
                  // Here we'll simulate a server response with 500ms of delay.
                  //setTimeout(() => resolve(res), 1000);
                  //console.log(res);
                  resolve(res)
                }
              });   
            }
        });
    });
};
class Embarques extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            modal       : false,
            prospectoid : null,
            title       : "Movimiento",
             data: [],
             pages: null,
             loading: true

        };
        this.toggle 			= this.toggle.bind(this);
        this.fetchData = this.fetchData.bind(this);
    }
    get_cliente(cliente = null){
    
    
          
  
  }
 fetchData(state, instance) {
    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true });
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered
    ).then(res => {
      // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
      this.setState({
        data: res.rows,
        pages: res.pages,
        loading: false
      });
      this.props.get(res.rows);
    });
  }
   toggle(evt, prospectoid = null, title = "Nueva Movimiento")
    {
        let {modal} = this.state;

        this.setState({
            modal       : !modal,
            prospectoid : prospectoid,
            title       : title,
            
        });
    }

    cancelar(evt, compra){
      console.log('compra------>',compra)
      let self = this;
      swal.queue([{
        title: 'Estas seguro?',
        text: "Se Cacelara el Movimiento "+compra.referencia+" para "+compra.proveedor+' Por la cantidad de '+compra.total,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
        cancelButtonText: 'Cancelar!',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return api().get('/movimientocap/cancelar/'+compra.value)
            .then(function(response)
            {    
                
                  
                     self.props.actualizar_renglon(response.data);
                     self.props.alerta({
                          mensaje:"Se Cancelo Correctamente el Movimiento: "+response.data.referencia,
                          tipo:"success",
                          creacion:moment().format('Y-MM-DD H:m:s'),
                          });
                  
               
                 
                
            })
            .catch((error) => {
              console.log('error--->',error)
              swal.insertQueueStep({
                type: 'error',
                title: 'Solicitar ayuda a un Administrador',
              })
            })
        }
      }])
    }

    componentDidMount() {

       // this.props.get();
    }

    render() {
 const { data, pages, loading } = this.state;
        return(
            <div className="view">
            <Menu props={this.props}/>

                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 ">Lista de Cargos y Abonos a Prveedores</h1>
                    </header>
                </div>

                <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                        <div className="text-right">
                                <Button color="success" className="mb-2" onClick={this.toggle}>
                                    <IconPersonAdd />&nbsp;Agregar
                                </Button>
                            </div>
                            <ReactTable
                              getTrProps={(state, rowInfo, column) => {
                                  
                                  if(rowInfo === undefined){
                                          
                                          return{

                                          }
                                        }else{
                                           return{
                                            onDoubleClick: (evt)=>this.toggle(evt, rowInfo.original.value, 'Editar Movimiento')
                                        } 
                                  
                                    }
                              }}
                             
                              className = "-striped -highlight"
                              columns   = {[
                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    maxWidth:80,
                                    Cell: (row) =>
                                    {

                                      return(
                                            <div className="text-center">
                                             {
                                              (parseInt(row.original.cancelado)==0)&&
                                                <Button
                                                 color="success" 
                                                 className="btn-sm" 
                                                  onClick={(evt)=>this.toggle(evt, row.original.value, 'Editar Movimiento')}>
                                                    <IconEdit />
                                                </Button>
                                              }
                                              {' '}
                                                {
                                              (parseInt(row.original.cancelado)==0)&&
                                              <Button
                                                 color="warning" 
                                                 title=" Cancelar "
                                                 className="btn-sm" 
                                                 onClick={(evt)=>this.cancelar(evt, row.original)}>
                                                    <IconBan />
                                                </Button>
                                            }
                                                 
                                            </div>
                                        )
                                        
                                    }
                                },
                                {Header: 'Estado', accessor: 'estado',maxWidth:150,minWidth:150 , filterable: false, style: { 'textAlign': 'center'}},
                                {Header: 'Tipo', accessor: 'tipo',maxWidth:150,minWidth:150 , filterable: false, style: { 'textAlign': 'center'}},
                                {Header: 'Referencia', accessor: 'referencia',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                {Header: 'RefDoc', accessor: 'refdoc',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                {Header: 'Concepto', accessor: 'concepto' ,minWidth:500, style: { 'textAlign': 'left'}},
                                {Header: 'Fecha', accessor: 'fecha',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                {Header: 'CodProv', accessor: 'codigo_proveedor' ,maxWidth:150,minWidth:150, style: { 'textAlign': 'center'}},
                                {Header: 'Proveedor', accessor: 'proveedor' ,minWidth:500, style: { 'textAlign': 'left'}}, 
                                {Header: 'Cantidad', accessor: 'cantidad',maxWidth:150,minWidth:150 , filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                                {Header: 'Impuestos', accessor: 'impuestos',maxWidth:150,minWidth:150 , filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                                {Header: 'Total', accessor: 'total',maxWidth:150,minWidth:150 , filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                              
                              ]}
                            
                              manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                              data={this.props.movimientocaproveedores.data}
                              pages={pages} // Display the total number of pages
                              loading={loading} // Display the loading overlay when we need it
                              onFetchData={_.debounce(this.fetchData, 500)} // Request new data when things change
                              filterable
                              defaultPageSize={10}
                             
                              
                             
                            />
                        </CardBlock>
                    </Card>
                </div>
                {
                   this.state.modal&& 
                   <Modal 
                 open={this.state.modal} 
                 toggle={this.toggle} 
                 title={this.state.title} 
                 prospectoid={this.state.prospectoid}
                 get_cliente={this.get_cliente}
                />
                }
                 

            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        movimientocaproveedores : state.movimientocaproveedores,
    }
};

export default connect(mapStateToProps, actions)(Embarques)


// WEBPACK FOOTER //
// ./src/views/movimientoscaproveedores/index.js